import React from 'react';
import { ScenarioType } from './types';
interface ScenarioSelectorProps {
  selectedScenario: ScenarioType;
  onScenarioChange: (scenario: ScenarioType) => void;
}
export function ScenarioSelector({
  selectedScenario,
  onScenarioChange
}: ScenarioSelectorProps) {
  return <div className="flex items-center space-x-4">
      <span className="text-sm font-medium text-theme-secondary">
        Scenario:
      </span>
      <div className="flex bg-theme-tertiary rounded-lg p-1">
        <button onClick={() => onScenarioChange('bull')} className={`px-4 py-1.5 text-xs font-medium rounded-md transition-colors ${selectedScenario === 'bull' ? 'bg-green-600 text-theme-primary' : 'text-theme-secondary hover:bg-theme-tertiary/70'}`}>
          Bull
        </button>
        <button onClick={() => onScenarioChange('base')} className={`px-4 py-1.5 text-xs font-medium rounded-md transition-colors ${selectedScenario === 'base' ? 'bg-blue-600 text-theme-primary' : 'text-theme-secondary hover:bg-theme-tertiary/70'}`}>
          Base
        </button>
        <button onClick={() => onScenarioChange('bear')} className={`px-4 py-1.5 text-xs font-medium rounded-md transition-colors ${selectedScenario === 'bear' ? 'bg-red-600 text-theme-primary' : 'text-theme-secondary hover:bg-theme-tertiary/70'}`}>
          Bear
        </button>
      </div>
    </div>;
}